/* eslint-disable no-param-reassign */

import { createSlice, PayloadAction, createAsyncThunk } from '@reduxjs/toolkit';
import { get } from '../../services/GenesisApi';
import {
  GET_GEMINI_HEALTH,
  GEMINI_HEALTHY_MESSAGE,
} from '../../constants/Gemini';

const GET_ACTIVE_NOTIFICATIONS = '/api/Notification/GetActiveNotification';

export interface INotificationMessage {
  messageDate: string;
  message: string;
}

interface IMessage {
  MessageDate: string;
  Message: string;
}

export interface INotification {
  notificationCount: number;
  notificationList: INotificationMessage[];
  loading?: boolean;
  isGeminiHealthy?: boolean;
  errorGeminiHealth?: boolean;
}

export const initialState: INotification = {
  notificationCount: 0,
  notificationList: [],
  loading: false,
  isGeminiHealthy: false,
  errorGeminiHealth: false,
};

export const getActiveNotifications = createAsyncThunk(
  'notifications/getActiveNotifications',
  async () => {
    return get(GET_ACTIVE_NOTIFICATIONS, {})
      .then((response) => {
        return response.data || [];
      })
      .catch((error) => {
        throw error;
      });
  }
);

export const getGeminiHealth = createAsyncThunk(
  'notifications/getGeminiHealth',
  async () => {
    return get(GET_GEMINI_HEALTH, {})
      .then((response) => {
        return response.data || false;
      })
      .catch((error) => {
        throw error;
      });
  }
);

const Notifications = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    updateNotifications: (
      state: INotification,
      { payload }: PayloadAction<IMessage[]>
    ) => {
      state.notificationList = payload.map((item) => ({
        messageDate: item.MessageDate,
        message: item.Message,
      }));
      state.notificationCount = payload.length;
    },
    updateGeminiHealthCheck: (
      state: INotification,
      { payload }: PayloadAction<boolean>
    ) => {
      state.isGeminiHealthy = payload;
      state.errorGeminiHealth = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getActiveNotifications.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getActiveNotifications.fulfilled,
        (state, { payload }: PayloadAction<INotificationMessage[]>) => {
          state.loading = false;
          state.notificationList = payload;
          state.notificationCount = payload.length;
        }
      )
      .addCase(getActiveNotifications.rejected, (state) => {
        state.loading = false;
        state.notificationList = [];
        state.notificationCount = 0;
      })
      .addCase(
        getGeminiHealth.fulfilled,
        (state, { payload }: PayloadAction<string>) => {
          state.isGeminiHealthy = payload === GEMINI_HEALTHY_MESSAGE;
          state.errorGeminiHealth = false;
        }
      )
      .addCase(getGeminiHealth.rejected, (state) => {
        state.errorGeminiHealth = true;
      });
  },
});

export const notificationActions = Notifications.actions;
export default Notifications.reducer;
